export default "__VITE_ASSET__DANOjPzr__"